<template>
  <div class="content">
    <div class="newActive">
      <span>最新活动</span>
      <div class="block">
        <div class="swiper">
          <el-carousel
            class="carousel"
            :interval="4000"
            arrow="never"
            :height="autoHeight"
          >
            <el-carousel-item v-for="item of image" :key="item.id">
              <div class="wrapper">
                <el-image
                  @click="signUp(item.id, item)"
                  class="swiper-img"
                  :src="item.banner_img_url"
                ></el-image>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="oldActive">
        <span>往期活动</span>
      </div>
      <el-form
        size="mini"
        ref="form"
        :model="course_form"
        label-position="left"
        class="form"
        @submit.native.prevent
      >
        <el-form-item label="所属科目">
          <el-radio-group
            @change="changeSubject1"
            v-model="course_form.subject_id"
          >
            <el-radio label="all">全部</el-radio>
            <el-radio
              v-for="item of subjectList"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-radio
            >
            <el-radio label="0">公开活动</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="课程类型">
          <el-radio-group
            v-model="course_form.activity_type"
            @change="changeSubjectType"
          >
            <el-radio label>全部</el-radio>
            <el-radio :label="1">技能提升</el-radio>
            <el-radio :label="2">教学技巧</el-radio>
            <el-radio :label="3">其他分享</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input_left">
          <el-input
            v-model="course_form.title"
            placeholder="请输入活动的名称"
            @keyup.enter.native="search"
            clearable
          ></el-input>
          <el-button type="primary" style="margin-left: 20px" @click="search"
            >搜索</el-button
          >
        </el-form-item>
        <div class="icon_right">
          <div class="new">
            <div class="new_txt" @click="time">时间</div>
            <div
              class="el-icon-caret-top top1"
              v-if="bgNew"
              @click="newAscendingOrder"
            ></div>
            <div
              class="el-icon-caret-top top1"
              style="color: rgb(82, 157, 254)"
              v-if="bgNewColor"
              @click="newAscendingOrder"
            ></div>

            <div
              class="el-icon-caret-bottom bottom1"
              v-if="oldNew"
              @click="newdescendingOrder"
            ></div>
            <div
              class="el-icon-caret-bottom bottom1"
              v-if="oldNewColor"
              style="color: rgb(82, 157, 254)"
              @click="newdescendingOrder"
            ></div>
          </div>
          <div class="hot">
            <div class="hot_txt" @click="hot">热度</div>
            <div
              class="el-icon-caret-top top2"
              v-if="bgHot"
              @click="hotAscendingOrder"
            ></div>
            <div
              class="el-icon-caret-top top2"
              style="color: rgb(82, 157, 254)"
              v-if="bgHotColor"
              @click="hotAscendingOrder"
            ></div>

            <div
              class="el-icon-caret-bottom bottom2"
              v-if="oldHot"
              @click="hotdescendingOrder"
            ></div>
            <div
              class="el-icon-caret-bottom bottom2"
              v-if="oldHotColor"
              style="color: rgb(82, 157, 254)"
              @click="hotdescendingOrder"
            ></div>
          </div>
        </div>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="6" v-for="item of curriculumList" :key="item.id">
          <div class="video_list">
            <div
              @click="handleClickCard(item)"
              class="courses_img"
              :style="{
                backgroundImage: 'url(' + item.img_url + ')',
              }"
            ></div>
            <div class="courses_title">
              <div style="overflow: hidden;width: 100%;">
                <div class="title_subject" style="width: 60%;">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.title"
                    placement="top"
                  >
                    <div class="title_name">{{ item.title }}</div>
                  </el-tooltip>
                </div>
                <div class="top_tag">{{ item.activity_type }}</div>
              </div>
              <div style="width: 100%; margin-top: 10px">
                <span>主持人：{{ item.host }}</span> | 活动时间：
                <span>
                  {{ item.activity_start_date }} -
                  {{ item.activity_end_date.slice(11) }}
                </span>
              </div>
              <div class="title_bottom">
                <div class="right_bottom">{{ item.tch_num }}人已参加</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  activityList,
  signUp,
  previousPeriod,
} from '@/api/teachingResearchTraining.js'
import { tchGetTchSubjectAuth } from '@/api/classroom/teacher_api'

export default {
  data() {
    return {
      autoHeight: '0px', //轮播图自适应高度

      bgNewColor: true,
      bgNew: false,
      oldNew: true,
      oldNewColor: false,
      bgHotColor: false,
      bgHot: true,
      oldHot: true,
      oldHotColor: false,
      num: [],
      image: [], //置顶轮播
      sort_type: '1',
      page_size: 12,
      page_no: 1,
      total: 0,
      course_form: {
        subjectIds: [],
        subject_id: 'all',
        activity_type: '',
        name: '',
      },
      curriculumList: [],
      subjectList: [],
      subjectList1: [],
    }
  },
  created() {},
  mounted() {
    this.getAutoHeight()

    this.tchGetTchSubjectAuth()
  },

  methods: {
    hot() {
      if (this.bgHotColor == false) {
        this.bgHotColor = true
        this.bgHot = false
        this.oldHot = true
        this.oldHotColor = false
        //
        this.bgNewColor = false
        this.bgNew = true
        this.oldNew = true
        this.oldNewColor = false
        this.sort_type = '3'
        this.previousPeriod()
      } else {
        this.bgHotColor = false
        this.bgHot = true
        this.oldHot = false

        this.oldHotColor = true
        //
        this.bgNewColor = false
        this.bgNew = true
        this.oldNew = true
        this.oldNewColor = false
        this.sort_type = '4'
        this.previousPeriod()
      }
    },
    time() {
      if (this.bgNewColor === true) {
        this.bgNewColor = false
        this.bgNew = true
        this.oldNewColor = true
        this.oldNew = false
        this.sort_type = '2'
        this.previousPeriod()
      } else {
        this.bgNewColor = true
        this.bgNew = false
        this.oldNew = true
        this.oldNewColor = false
        // //
        this.bgHotColor = false
        this.bgHot = true
        this.oldHot = true
        this.oldHotColor = false
        this.sort_type = '1'
        this.previousPeriod()
      }
    },
    getAutoHeight() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth
      this.autoHeight = _w * 0.17 + 'px'
      // this.autoHeight_top_course = _w * 1.17 * 0.23 + "px";

      // this.autoHeight_teacher = _w * 1.5 * 0.23 + "px";

      // this.autoHeight_code = _w * 1.5 * 0.23 + "px";

      // this.autoHeight_photo = _w * 2.0 * 0.17 + "px";
    },
    // ces() {
    //   this.activityList();
    // },
    changeSubjectType(val) {
      this.page_no = 1
      this.course_form.activity_type = val
      this.previousPeriod()
    },
    search() {
      this.page_no = 1
      this.previousPeriod()
    },
    getinfo() {
      this.course_form.subjectIds = this.subjectList
      console.log(this.course_form.subjectIds, 123456)
      let newArr = []
      this.course_form.subjectIds.forEach((item) => {
        console.log(item, 666666666)
        console.log(item.id, 666666666)

        newArr.push(item.id)
      })
      console.log(newArr, 456789)

      this.course_form.subjectIds = newArr
      console.log(this.course_form.subjectIds, 222)

      this.num = newArr
    },
    changeSubject(val) {
      console.log(val)
      if (val === '') {
        this.course_form.subjectIds = this.subjectList
        console.log(this.course_form.subjectIds, 123456)
        let newArr = []
        this.course_form.subjectIds.forEach((item) => {
          newArr.push(item.id)
          console.log(newArr, 456789)
        })
        console.log(newArr, 456789)

        this.course_form.subjectIds = newArr
        console.log(this.course_form.subjectIds, 222)
      } else {
        this.course_form.subjectIds = [val]
        console.log(this.course_form.subjectIds, 'ces')
      }

      this.previousPeriod()
    },
    changeSubject1(val) {
      this.page_no = 1

      console.log(val, 23323)
      if (val === 'all') {
        this.course_form.subject_id = 'all'
      }
      this.previousPeriod()
    },
    //往期活动列表
    previousPeriod() {
      previousPeriod({
        selectedSubjectId: this.course_form.subject_id,
        title: this.course_form.title,
        activity_type: this.course_form.activity_type,
        sort_type: this.sort_type,
        subjectIds: JSON.stringify(this.subjectList1),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.curriculumList = res.researchActivityList
        res.researchActivityList.map((index) => {
          if (index.activity_type === 1) {
            return (index.activity_type = '技能提升')
          }
          if (index.activity_type === 2) {
            return (index.activity_type = '教学技巧')
          }
          if (index.activity_type === 3) {
            return (index.activity_type = '其他分享')
          }
        })
        this.total = res.total
      })
    },
    //最新升序
    newAscendingOrder() {
      this.page_no = 1
      this.bgNewColor = true
      this.bgNew = false
      this.oldNew = true
      this.oldNewColor = false
      //
      this.bgHotColor = false
      this.bgHot = true
      this.oldHot = true
      this.oldHotColor = false
      this.sort_type = '1'
      this.previousPeriod()
    },
    //最新降序
    newdescendingOrder() {
      this.page_no = 1

      this.bgNewColor = false
      this.bgNew = true

      this.oldNew = false

      this.oldNewColor = true
      //
      this.bgHotColor = false
      this.bgHot = true
      this.oldHot = true
      this.oldHotColor = false

      this.sort_type = '2'
      this.previousPeriod()
    },
    //最热升序
    hotAscendingOrder() {
      this.page_no = 1

      this.bgHotColor = true
      this.bgHot = false
      this.oldHot = true
      this.oldHotColor = false
      //
      this.bgNewColor = false
      this.bgNew = true
      this.oldNew = true
      this.oldNewColor = false

      this.sort_type = '3'
      this.previousPeriod()
    },
    //最热降序
    hotdescendingOrder() {
      this.page_no = 1

      this.bgHotColor = false
      this.bgHot = true
      this.oldHot = false

      this.oldHotColor = true
      //
      this.bgNewColor = false
      this.bgNew = true
      this.oldNew = true
      this.oldNewColor = false

      this.sort_type = '4'
      this.previousPeriod()
    },
    //分页
    handleCurrent(val) {
      this.page_no = val
      this.previousPeriod()
    },

    //获取学校科目权限列表
    tchGetTchSubjectAuth() {
      console.log('查询老师科目权限')
      tchGetTchSubjectAuth().then((res) => {
        this.subjectList = res.subjectList
        console.log(this.subjectList, 4567897922222)
        this.subjectList1 = []
        this.subjectList.map((item) => {
          this.subjectList1.push(item.id)
        })
        console.log(this.subjectList1, 4567897922222)

        console.log('获取老师权限列表')
        console.log(res)
        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }
        this.getinfo()
        this.previousPeriod()
        this.activityList()
      })
    },
    //报名接口
    signUp(id, item) {
      console.log(id, 666666666666)
      console.log(item)
      signUp({
        research_activity_id: id,
        operate_state: 1,
      }).then((res) => {
        console.log(res)
        this.$router.push({
          name: 'teachingAndResearchTrainingNewDetails',
          query: {
            image: JSON.stringify(item),
          },
        })
      })
    },
    //获取置顶列表
    activityList() {
      activityList({
        subjectIds: JSON.stringify(this.num),
      }).then((res) => {
        this.image = res.researchActivityList
        console.log(res, 8888888888)
      })
    },
    handleClickCard(item) {
      console.log(item)

      if (!this.$store.state.user.schoolInfo.isTry) {
        signUp({
          research_activity_id: item.id,
          operate_state: 1,
        }).then((res) => {
          console.log(res)
          this.$router.push({
            name: 'teachingAndResearchTrainingOldDetails',
            query: {
              curriculumList: JSON.stringify(item),
            },
          })
        })
      } else {
        this.$message.warning('体验账号,暂无权限查看!')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  height: 63px;
  background-color: #fff;
  line-height: 63px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}

.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}

.newActive {
  width: 100%;
  // height: 341px;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 5px;
}

.newActive span {
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
}

.oldActive span {
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
}

.block {
  margin-top: 15px;
}

.main {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 400px);
  background-color: #fff;
  margin-top: 10px;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 5px;
}

.main .el-input {
  width: 337px;
  height: 30px;
}

.form {
  overflow: hidden;
  margin-top: 15px;
}

.input_left {
  float: left;
}

.icon_right {
  float: right;
  cursor: pointer;
}

.new {
  position: relative;
  top: 0;
  right: 75px;
}

.top1 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom1 {
  position: absolute;
  top: 8px;
  left: 0;
}

.new_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.hot {
  position: relative;
  top: 0;
  right: 10px;
}

.top2 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom2 {
  position: absolute;
  top: 8px;
  left: 0;
}

.hot_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.video_list {
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
  border-radius: 5px;
  // background: white;
  cursor: pointer;
}

.courses_img {
  height: 0;
  padding-bottom: 69%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 5px 5px 0px 0px;
}

.courses_title {
  flex: 1;
  padding: 10px;
}

.top_tag {
  float: right;
  margin-left: 10px;
  color: rgb(241, 90, 36);
  font-size: 10px;
  border: 1px solid rgb(241, 90, 36);
  padding: 2px 4px;
  border-radius: 5px;
  // padding: 5px;
  // color: rgba(255, 255, 255, 1);
  // background-color: rgba(24, 144, 255, 1);
  // border-radius: 4px;
  // font-size: 14px;
  // line-height: 26px;
  // text-align: center;
}

.title_subject {
  text-align: center;
  line-height: 26px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
  float: left;
}

.title_bottom {
  color: rgba(80, 80, 80, 1);
  font-size: 14px;
  overflow: hidden;
  margin-top: 10px;
}

.left_bottom {
  float: left;
}

.right_bottom {
  // float: right;
}

/deep/ .el-breadcrumb {
  line-height: 63px;
  padding-left: 20px;
}

.title_name {
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  display: -webkit-box;
  -webkit-line-clamp: 1; // 超出多少行
  -webkit-box-orient: vertical;
  text-align: left;
}

.wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 10.6%;
}

.swiper-img {
  width: 100%;
  object-fit: fill;
}
</style>
